// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","listInfrastructure":"infrastructure_listInfrastructure__a+r9S","cheked":"infrastructure_cheked__86dHR"};